import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { DocumentAccessCredentialsModel } from '@data-layer/models/documents';

@Injectable({
  providedIn: 'root',
})
export class CompanyLogoRepository {
  constructor(private apiService: ApiService) {}

  public getCredentials(companyId: number, isShowLoader: boolean = false): Observable<DocumentAccessCredentialsModel> {
    return this.apiService.get<DocumentAccessCredentialsModel>(`${environment.url.companies}${companyId}/logo/upload-credentials`, null, {
      isShowLoader,
    });
  }

  public setUrl(companyId: number, uri: string, isShowLoader: boolean = false): Observable<DocumentAccessCredentialsModel> {
    return this.apiService.put<DocumentAccessCredentialsModel>(
      `${environment.url.companies}${companyId}/logo-url`,
      JSON.stringify(uri),
      null,
      {
        isShowLoader,
      },
    );
  }

  public deleteUrl(companyId: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.delete(`${environment.url.companies}${companyId}/logo-url`, null, { isShowLoader });
  }
}
